export default "__VITE_ASSET__gxzfkFFg__"